/**
 * Esecuzione di un'azione del core con stato "in corso", toast di conferma (solo per azioni dell'utente
 * in quella pagina, 15 sez. 1 regola 5) e testo d'errore in italiano semplice.
 */
import { useCallback, useState } from 'react';
import toast from 'react-hot-toast';
import type { ApiResult } from './api';
import { commerceErrorText, type ErrorTextCtx } from './errorText';

export function useCommerceAction() {
  const [busy, setBusy] = useState<string | null>(null);

  const run = useCallback(async <T,>(
    key: string,
    fn: () => Promise<ApiResult<T>>,
    o: { success?: string; ctx?: ErrorTextCtx; silentError?: boolean } = {},
  ): Promise<ApiResult<T>> => {
    setBusy(key);
    try {
      const r = await fn();
      if (r.ok) {
        if (o.success) toast.success(o.success);
      } else if (!o.silentError) {
        toast.error(commerceErrorText(r.code, r.message, o.ctx));
      }
      return r;
    } finally {
      setBusy(null);
    }
  }, []);

  return { busy, run };
}
